<template>
  <div class="container-fluid top-navigation" :class="{ onTop }">
    <b-modal
      size="lg"
      ref="modalExitGame"
      id="error-modal"
      hide-header
      body-text-variant="light"
      centered
    >
      Are you sure you want to exit?
      <div slot="modal-footer" style="width: 100%">
        <div class="row">
          <div class="col-6">
            <button class="btn btn-secondary" style="width: 50%" @click="goTo(to, true)">YES</button>
          </div>
          <div class="col-6">
            <button class="btn btn-secondary" style="width: 50%" @click="closeModal()">NO</button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-popover target="avatar-icon"
               placement="rightbottom"
               triggers="blur"
               class="prizes"
    >
      Great work – check out what you’ve unlocked!
       <!-- Well done – you’ve earnt <span v-if="diffTotalFoundFactCards > 0">{{ diffTotalFoundFactCards }} more fact card<span v-if="diffTotalFoundFactCards > 1">s</span></span><span v-if="diffTotalFoundFactCards > 0 && diffTotalFoundFactFiles > 0"> and </span><span v-if="diffTotalFoundFactFiles > 0">{{ diffTotalFoundFactFiles }} more fact file<span v-if="diffTotalFoundFactFiles > 1">s</span></span>!
      -->
      <br />
      <br />
      <router-link class="btn btn-secondary" to="/wallet">My wallet</router-link>
    </b-popover>
    <div class="row">
      <div class="navigation-wrapper" :class="[colLeft]">
        <button v-if="showBack" @click="$router.go(-1)" class="btn btn-primary ng-default-btn float-left"><i class="fas fa-chevron-left"></i></button>
        <a v-if="closeGame" @click="closeGameIFrame()" class="btn btn-primary ng-default-btn float-left ml-2"><i class="fas fa-times"></i></a>
        <a v-if="showReload" @click="reload()" class="btn btn-primary ng-default-btn float-left ml-2"><i class="fas fa-redo"></i></a>
        <a @click="goTo('/selection')" v-if="showHome && $route.path !== '/selection'" class="btn btn-primary ng-default-btn float-left ml-2"><i class="fas fa-home"></i></a>
        <!-- <a @click="fullScreen()" v-if="showFullScreen && fullScreenAvailable" class="btn btn-primary ng-default-btn float-left ml-2"><i class="fas fa-expand"></i></a> -->
        <a @click="goTo('/wallet')" v-show="showAvatar" id="avatar-icon" class="float-left" :class="{ 'ml-2': showBack || showHome}">
          <img class="avatar" v-if="showAvatar" :src="avatar.avatarImage"/>
        </a>
        <slot name="left"></slot>
      </div>
      <div class="col-4 navigation-wrapper text-center" v-if="showMiddleSlot">
        <slot name="middle"></slot>
      </div>
      <div class="navigation-wrapper text-right" :class="[colRight]">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import screenfull from 'screenfull'

export default {
  name: 'TopNavigation',
  computed: {
    ...mapGetters(['avatar', 'factCardsList', 'diffTotalFoundFactFiles', 'diffTotalFoundFactCards']),
    fullScreenAvailable () {
      try {
        return window.self === window.top && screenfull.enabled !== undefined
      } catch (e) {
        return false
      }
    },
    closeGame () {
      return window.fullscreenIframe
    }
  },
  props: {
    showBack: {
      default: true
    },
    showAvatar: {
      default: true
    },
    showHome: {
      default: true
    },
    inGame: {
      default: false
    },
    colLeft: {
      default: 'col-4'
    },
    colRight: {
      default: 'col-4'
    },
    showMiddleSlot: {
      default: true
    },
    showFullScreen: {
      default: true
    },
    onTop: {
      default: false
    },
    showReload: {
      default: false
    },
    closeGameAlt: {
      default: false
    }
  },
  data () {
    return {
      to: '',
      showPopover: false,
      closeFromIFrameBtn: false
    }
  },
  methods: {
    closeModal () {
      this.$refs.modalExitGame.hide()
      this.closeFromIFrameBtn = false
    },
    goTo (to, isOk = false) {
      if (this.inGame) {
        this.to = to
        this.$refs.modalExitGame.show()
      }
      if (isOk || !this.inGame) {
        this.$router.push(to)
      }
      if (this.closeFromIFrameBtn && isOk) {
        window.top.postMessage('closeGameIFrame', window.fullscreenIframe)
      }
    },
    closeGameIFrame () {
      if (this.closeGameAlt) {
        window.top.postMessage('closeGameIFrame', window.fullscreenIframe)
      } else {
        this.$refs.modalExitGame.show()
        this.closeFromIFrameBtn = true
      }
    },
    reload () {
      window.location.reload()
    }
  }
}
</script>

<style scoped>
  .navigation-wrapper .avatar {
    width: 5vw;
  }

  .navigation-wrapper img {
    max-width: 5vw;
  }

  .navigation-wrapper .btn {
    border-radius: 100%;
    width: 5vw;
    height: 5vw;
    font-size: 1.7vw;
    z-index: 1;
  }

  a {
    color: #000 !important;
    cursor: pointer;
  }

  .onTop {
    position: absolute;
    z-index: 999;
  }
</style>
